module.exports = __webpack_public_path__ + "static/img/img(51).3e35df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(51).png
// module id = +/2A
// module chunks = 1